import { render, staticRenderFns } from "./MentionableEditor.vue?vue&type=template&id=2c64b8de&scoped=true"
import script from "./MentionableEditor.vue?vue&type=script&lang=js"
export * from "./MentionableEditor.vue?vue&type=script&lang=js"
import style0 from "./MentionableEditor.vue?vue&type=style&index=0&id=2c64b8de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c64b8de",
  null
  
)

export default component.exports